export default class ObserverAnimation {
  init() {
    const elementsToObserve = Array.from(
      document.querySelectorAll('.observer-animation-element')
    );

    if (!elementsToObserve.length) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('observer-animation-is-active');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.75,
      }
    );

    for (let element of elementsToObserve) {
      observer.observe(element);
    }

    requestAnimationFrame(() => {
      for (let element of elementsToObserve) {
        element.classList.add('observer-animation-initialized');

        // if the element is already visible, add the class immediately
        if (element.getBoundingClientRect().top < window.innerHeight) {
          element.classList.add('observer-animation-is-active');
          observer.unobserve(element);
        }
      }
    });
  }
}
